import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';
import './GestionProducto.css';

function FVendedor({ usuario }) {
    const [vendedores, setVendedores] = useState([]);
    const [vendedoresFiltrados, setVendedoresFiltrados] = useState([]);
    const [paises, setPaises] = useState([]);
    const [ciudades, setCiudades] = useState([]);
    const [ciudadesFiltradas, setCiudadesFiltradas] = useState([]);
    const [busqueda, setBusqueda] = useState('');
    const [modalAbierto, setModalAbierto] = useState(false);
    const [modoEdicion, setModoEdicion] = useState(false);
    const [formulario, setFormulario] = useState({
        idVendedor: '',
        nomVendedor: '',
        rucVendedor: '',
        direccion: '',
        barrio: '',
        idPais: '',
        idCiudad: '',
        telefono: '',
        obs: '',
        idOperador: usuario || ''
    });

    // Estados para selector de país
    const [paisSeleccionado, setPaisSeleccionado] = useState(null);
    const [dropdownPaisAbierto, setDropdownPaisAbierto] = useState(false);
    const [busquedaPais, setBusquedaPais] = useState('');
    const dropdownPaisRef = useRef(null);

    // Estados para selector de ciudad
    const [ciudadSeleccionada, setCiudadSeleccionada] = useState(null);
    const [dropdownCiudadAbierto, setDropdownCiudadAbierto] = useState(false);
    const [busquedaCiudad, setBusquedaCiudad] = useState('');
    const dropdownCiudadRef = useRef(null);

    // Paginación
    const [paginaActual, setPaginaActual] = useState(1);
    const [itemsPorPagina, setItemsPorPagina] = useState(10);

    const API_VENDEDORES_URL = '/api/vendedores';
    const API_PAISES_URL = '/api/paises';
    const API_CIUDADES_URL = '/api/ciudades';

    useEffect(() => {
        cargarVendedores();
        cargarPaises();
        cargarCiudades();
    }, []);

    useEffect(() => {
        filtrarVendedores();
    }, [busqueda, vendedores]);

    // Cerrar dropdowns al hacer clic fuera
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownPaisRef.current && !dropdownPaisRef.current.contains(event.target)) {
                setDropdownPaisAbierto(false);
            }
            if (dropdownCiudadRef.current && !dropdownCiudadRef.current.contains(event.target)) {
                setDropdownCiudadAbierto(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // Filtrar ciudades cuando cambia el país seleccionado
    useEffect(() => {
        if (paisSeleccionado) {
            const ciudadesPais = ciudades.filter(c => c.idPais === paisSeleccionado.idPais);
            setCiudadesFiltradas(ciudadesPais);
        } else {
            setCiudadesFiltradas([]);
        }
    }, [paisSeleccionado, ciudades]);

    const cargarVendedores = async () => {
        try {
            const response = await axios.get(API_VENDEDORES_URL);
            setVendedores(response.data);
            setVendedoresFiltrados(response.data);
        } catch (error) {
            console.error('Error al cargar vendedores:', error);
            alert('Error al cargar los vendedores');
        }
    };

    const cargarPaises = async () => {
        try {
            const response = await axios.get(API_PAISES_URL);
            setPaises(response.data);
        } catch (error) {
            console.error('Error al cargar países:', error);
        }
    };

    const cargarCiudades = async () => {
        try {
            const response = await axios.get(API_CIUDADES_URL);
            setCiudades(response.data);
        } catch (error) {
            console.error('Error al cargar ciudades:', error);
        }
    };

    const filtrarVendedores = () => {
        if (!busqueda) {
            setVendedoresFiltrados(vendedores);
            setPaginaActual(1);
            return;
        }

        const filtrados = vendedores.filter(vendedor =>
            vendedor.idVendedor?.toString().includes(busqueda) ||
            vendedor.nomVendedor?.toLowerCase().includes(busqueda.toLowerCase()) ||
            vendedor.rucVendedor?.includes(busqueda)
        );
        setVendedoresFiltrados(filtrados);
        setPaginaActual(1);
    };

    // Funciones del selector de país
    const filtrarPaises = (busqueda) => {
        if (!busqueda) return paises;
        return paises.filter(pais =>
            pais.idPais?.toLowerCase().includes(busqueda.toLowerCase()) ||
            pais.nomPais?.toLowerCase().includes(busqueda.toLowerCase())
        );
    };

    const seleccionarPais = (pais) => {
        setPaisSeleccionado(pais);
        setFormulario({ ...formulario, idPais: pais.idPais, idCiudad: '' });
        setCiudadSeleccionada(null);
        setBusquedaPais('');
        setDropdownPaisAbierto(false);
    };

    const limpiarPais = () => {
        setPaisSeleccionado(null);
        setCiudadSeleccionada(null);
        setFormulario({ ...formulario, idPais: '', idCiudad: '' });
        setBusquedaPais('');
        setBusquedaCiudad('');
    };

    // Funciones del selector de ciudad
    const filtrarCiudadesSelector = (busqueda) => {
        if (!busqueda) return ciudadesFiltradas.slice(0, 100);
        return ciudadesFiltradas.filter(ciudad =>
            ciudad.idCiudad?.toString().includes(busqueda) ||
            ciudad.nomCiudad?.toLowerCase().includes(busqueda.toLowerCase())
        );
    };

    const seleccionarCiudad = (ciudad) => {
        setCiudadSeleccionada(ciudad);
        setFormulario({ ...formulario, idCiudad: ciudad.idCiudad });
        setBusquedaCiudad('');
        setDropdownCiudadAbierto(false);
    };

    const limpiarCiudad = () => {
        setCiudadSeleccionada(null);
        setFormulario({ ...formulario, idCiudad: '' });
        setBusquedaCiudad('');
    };

    const abrirModalNuevo = () => {
        setFormulario({
            idVendedor: '',
            nomVendedor: '',
            rucVendedor: '',
            direccion: '',
            barrio: '',
            idPais: '',
            idCiudad: '',
            telefono: '',
            obs: '',
            idOperador: usuario || ''
        });
        setPaisSeleccionado(null);
        setCiudadSeleccionada(null);
        setBusquedaPais('');
        setBusquedaCiudad('');
        setModoEdicion(false);
        setModalAbierto(true);
    };

    const abrirModalEditar = (vendedor) => {
        setFormulario({
            idVendedor: vendedor.idVendedor,
            nomVendedor: vendedor.nomVendedor,
            rucVendedor: vendedor.rucVendedor,
            direccion: vendedor.direccion,
            barrio: vendedor.barrio || '',
            idPais: vendedor.idPais || '',
            idCiudad: vendedor.idCiudad || '',
            telefono: vendedor.telefono || '',
            obs: vendedor.obs || '',
            idOperador: usuario || ''
        });

        // Buscar y setear el país seleccionado
        if (vendedor.idPais) {
            const pais = paises.find(p => p.idPais === vendedor.idPais);
            if (pais) {
                setPaisSeleccionado(pais);
            }
        }

        // Buscar y setear la ciudad seleccionada
        if (vendedor.idPais && vendedor.idCiudad) {
            const ciudad = ciudades.find(c =>
                c.idPais === vendedor.idPais && c.idCiudad === vendedor.idCiudad
            );
            if (ciudad) {
                setCiudadSeleccionada(ciudad);
            }
        }

        setModoEdicion(true);
        setModalAbierto(true);
    };

    const cerrarModal = () => {
        setModalAbierto(false);
        setFormulario({
            idVendedor: '',
            nomVendedor: '',
            rucVendedor: '',
            direccion: '',
            barrio: '',
            idPais: '',
            idCiudad: '',
            telefono: '',
            obs: '',
            idOperador: usuario || ''
        });
        setPaisSeleccionado(null);
        setCiudadSeleccionada(null);
        setBusquedaPais('');
        setBusquedaCiudad('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formulario.nomVendedor.trim() || !formulario.rucVendedor.trim() || !formulario.direccion.trim()) {
            alert('Nombre, RUC y Dirección son obligatorios');
            return;
        }

        try {
            const vendedorData = {
                ...formulario,
                idOperador: usuario || formulario.idOperador
            };

            if (modoEdicion) {
                await axios.put(`${API_VENDEDORES_URL}/${formulario.idVendedor}`, vendedorData);
                alert('Vendedor actualizado exitosamente');
            } else {
                await axios.post(API_VENDEDORES_URL, vendedorData);
                alert('Vendedor creado exitosamente');
            }
            cargarVendedores();
            cerrarModal();
        } catch (error) {
            console.error('Error al guardar:', error);
            alert('Error al guardar el vendedor');
        }
    };

    const eliminar = async (id) => {
        if (window.confirm('¿Está seguro de eliminar este vendedor?')) {
            try {
                await axios.delete(`${API_VENDEDORES_URL}/${id}`);
                alert('Vendedor eliminado exitosamente');
                cargarVendedores();
            } catch (error) {
                console.error('Error al eliminar:', error);
                alert('Error al eliminar el vendedor');
            }
        }
    };

    const exportarExcel = () => {
        const datosExportar = vendedoresFiltrados.map(vendedor => ({
            'ID': vendedor.idVendedor,
            'Nombre': vendedor.nomVendedor,
            'RUC': vendedor.rucVendedor,
            'Dirección': vendedor.direccion,
            'Barrio': vendedor.barrio,
            'País': vendedor.nomPais,
            'Ciudad': vendedor.nomCiudad,
            'Teléfono': vendedor.telefono,
            'Observaciones': vendedor.obs
        }));

        const worksheet = XLSX.utils.json_to_sheet(datosExportar);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Vendedores');
        XLSX.writeFile(workbook, 'vendedores.xlsx');
    };

    // Paginación
    const indiceUltimo = paginaActual * itemsPorPagina;
    const indicePrimero = indiceUltimo - itemsPorPagina;
    const vendedoresActuales = vendedoresFiltrados.slice(indicePrimero, indiceUltimo);
    const totalPaginas = Math.ceil(vendedoresFiltrados.length / itemsPorPagina);

    const cambiarPagina = (numeroPagina) => {
        setPaginaActual(numeroPagina);
    };

    const cambiarItemsPorPagina = (e) => {
        setItemsPorPagina(Number(e.target.value));
        setPaginaActual(1);
    };

    return (
        <div className="present-container">
            <div className="header-seccion">
                <h2>Gestión de Vendedores</h2>
                <div className="acciones-header">
                    <input
                        type="text"
                        className="input-busqueda"
                        placeholder="Buscar..."
                        value={busqueda}
                        onChange={(e) => setBusqueda(e.target.value)}
                    />
                    <button className="btn btn-nuevo" onClick={abrirModalNuevo}>
                        ➕ Nuevo Vendedor
                    </button>
                    <button className="btn btn-exportar" onClick={exportarExcel}>
                        📊 Exportar a Excel
                    </button>
                </div>
            </div>

            <div className="tabla-container">
                <table className="tabla-datos">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Nombre</th>
                            <th>RUC</th>
                            <th>Dirección</th>
                            <th>País</th>
                            <th>Ciudad</th>
                            <th>Teléfono</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {vendedoresActuales.length === 0 ? (
                            <tr>
                                <td colSpan="8" className="sin-datos">No hay vendedores para mostrar</td>
                            </tr>
                        ) : (
                            vendedoresActuales.map(vendedor => (
                                <tr key={vendedor.idVendedor}>
                                    <td>{vendedor.idVendedor}</td>
                                    <td>{vendedor.nomVendedor}</td>
                                    <td>{vendedor.rucVendedor}</td>
                                    <td>{vendedor.direccion}</td>
                                    <td>{vendedor.nomPais}</td>
                                    <td>{vendedor.nomCiudad}</td>
                                    <td>{vendedor.telefono}</td>
                                    <td>
                                        <button
                                            onClick={() => abrirModalEditar(vendedor)}
                                            className="btn-accion"
                                            title="Editar"
                                        >
                                            ✏️
                                        </button>
                                        <button
                                            onClick={() => eliminar(vendedor.idVendedor)}
                                            className="btn-accion"
                                            title="Eliminar"
                                        >
                                            🗑️
                                        </button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            <div className="paginacion-container">
                <div className="paginacion-info">
                    <span>
                        Mostrando {indicePrimero + 1} a {Math.min(indiceUltimo, vendedoresFiltrados.length)} de {vendedoresFiltrados.length} registros
                    </span>
                    <select
                        value={itemsPorPagina}
                        onChange={cambiarItemsPorPagina}
                        className="select-registros"
                    >
                        <option value={5}>5 por página</option>
                        <option value={10}>10 por página</option>
                        <option value={20}>20 por página</option>
                        <option value={50}>50 por página</option>
                    </select>
                </div>

                <div className="paginacion-controles">
                    <button
                        onClick={() => cambiarPagina(1)}
                        disabled={paginaActual === 1}
                        className="btn-paginacion"
                        title="Primera página"
                    >
                        ⏮️
                    </button>
                    <button
                        onClick={() => cambiarPagina(paginaActual - 1)}
                        disabled={paginaActual === 1}
                        className="btn-paginacion"
                    >
                        ◀️
                    </button>

                    {[...Array(totalPaginas)].map((_, index) => {
                        const numeroPagina = index + 1;
                        if (
                            numeroPagina === 1 ||
                            numeroPagina === totalPaginas ||
                            (numeroPagina >= paginaActual - 1 && numeroPagina <= paginaActual + 1)
                        ) {
                            return (
                                <button
                                    key={numeroPagina}
                                    onClick={() => cambiarPagina(numeroPagina)}
                                    className={`btn-numero-pagina ${paginaActual === numeroPagina ? 'activo' : ''}`}
                                >
                                    {numeroPagina}
                                </button>
                            );
                        } else if (
                            numeroPagina === paginaActual - 2 ||
                            numeroPagina === paginaActual + 2
                        ) {
                            return <span key={numeroPagina}>...</span>;
                        }
                        return null;
                    })}

                    <button
                        onClick={() => cambiarPagina(paginaActual + 1)}
                        disabled={paginaActual === totalPaginas}
                        className="btn-paginacion"
                    >
                        ▶️
                    </button>
                    <button
                        onClick={() => cambiarPagina(totalPaginas)}
                        disabled={paginaActual === totalPaginas}
                        className="btn-paginacion"
                        title="Última página"
                    >
                        ⏭️
                    </button>
                </div>
            </div>

            {/* Modal */}
            {modalAbierto && (
                <div className="modal-overlay">
                    <div className="modal-contenido" style={{ maxWidth: '600px' }}>
                        <div className="modal-header">
                            <h3>{modoEdicion ? 'Editar Vendedor' : 'Nuevo Vendedor'}</h3>
                            <button onClick={cerrarModal} className="btn-cerrar">×</button>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label>Nombre del Vendedor *</label>
                                <input
                                    type="text"
                                    value={formulario.nomVendedor}
                                    onChange={(e) => setFormulario({ ...formulario, nomVendedor: e.target.value })}
                                    required
                                    maxLength={50}
                                    placeholder="Ingrese el nombre del vendedor"
                                />
                            </div>

                            <div className="form-group">
                                <label>RUC *</label>
                                <input
                                    type="text"
                                    value={formulario.rucVendedor}
                                    onChange={(e) => setFormulario({ ...formulario, rucVendedor: e.target.value })}
                                    required
                                    maxLength={12}
                                    placeholder="Ingrese el RUC"
                                />
                            </div>

                            <div className="form-group">
                                <label>Dirección *</label>
                                <input
                                    type="text"
                                    value={formulario.direccion}
                                    onChange={(e) => setFormulario({ ...formulario, direccion: e.target.value })}
                                    required
                                    maxLength={40}
                                    placeholder="Ingrese la dirección"
                                />
                            </div>

                            <div className="form-group">
                                <label>Barrio</label>
                                <input
                                    type="text"
                                    value={formulario.barrio}
                                    onChange={(e) => setFormulario({ ...formulario, barrio: e.target.value })}
                                    maxLength={20}
                                    placeholder="Ingrese el barrio"
                                />
                            </div>

                            <div className="form-group">
                                <label>País</label>
                                <div className="cuenta-selector" ref={dropdownPaisRef}>
                                    {paisSeleccionado ? (
                                        <div className="cuenta-seleccionada">
                                            <span>{paisSeleccionado.idPais} - {paisSeleccionado.nomPais}</span>
                                            <button type="button" onClick={limpiarPais} className="btn-limpiar">✕</button>
                                        </div>
                                    ) : (
                                        <input
                                            type="text"
                                            placeholder="Buscar país..."
                                            value={busquedaPais}
                                            onChange={(e) => setBusquedaPais(e.target.value)}
                                            onFocus={() => setDropdownPaisAbierto(true)}
                                            className="input-busqueda"
                                        />
                                    )}

                                    {dropdownPaisAbierto && !paisSeleccionado && (
                                        <div className="cuenta-dropdown">
                                            {filtrarPaises(busquedaPais).map(pais => (
                                                <div
                                                    key={pais.idPais}
                                                    className="cuenta-item"
                                                    onClick={() => seleccionarPais(pais)}
                                                >
                                                    <strong>{pais.idPais}</strong> - {pais.nomPais}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="form-group">
                                <label>Ciudad</label>
                                <div className="cuenta-selector" ref={dropdownCiudadRef}>
                                    {ciudadSeleccionada ? (
                                        <div className="cuenta-seleccionada">
                                            <span>{ciudadSeleccionada.idCiudad} - {ciudadSeleccionada.nomCiudad}</span>
                                            <button type="button" onClick={limpiarCiudad} className="btn-limpiar">✕</button>
                                        </div>
                                    ) : (
                                        <input
                                            type="text"
                                            placeholder={paisSeleccionado ? "Buscar ciudad..." : "Primero seleccione un país"}
                                            value={busquedaCiudad}
                                            onChange={(e) => setBusquedaCiudad(e.target.value)}
                                            onFocus={() => paisSeleccionado && setDropdownCiudadAbierto(true)}
                                            className="input-busqueda"
                                            disabled={!paisSeleccionado}
                                        />
                                    )}

                                    {dropdownCiudadAbierto && !ciudadSeleccionada && paisSeleccionado && (
                                        <div className="cuenta-dropdown">
                                            {filtrarCiudadesSelector(busquedaCiudad).map(ciudad => (
                                                <div
                                                    key={`${ciudad.idPais}-${ciudad.idCiudad}`}
                                                    className="cuenta-item"
                                                    onClick={() => seleccionarCiudad(ciudad)}
                                                >
                                                    <strong>{ciudad.idCiudad}</strong> - {ciudad.nomCiudad}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="form-group">
                                <label>Teléfono</label>
                                <input
                                    type="text"
                                    value={formulario.telefono}
                                    onChange={(e) => setFormulario({ ...formulario, telefono: e.target.value })}
                                    maxLength={20}
                                    placeholder="Ingrese el teléfono"
                                />
                            </div>

                            <div className="form-group">
                                <label>Observaciones</label>
                                <textarea
                                    value={formulario.obs}
                                    onChange={(e) => setFormulario({ ...formulario, obs: e.target.value })}
                                    maxLength={200}
                                    placeholder="Ingrese observaciones"
                                    rows={3}
                                    style={{ width: '100%', resize: 'vertical' }}
                                />
                            </div>

                            <div className="modal-footer">
                                <button type="button" onClick={cerrarModal} className="btn btn-cancelar">
                                    Cancelar
                                </button>
                                <button type="submit" className="btn btn-guardar">
                                    {modoEdicion ? 'Actualizar' : 'Guardar'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}

export default FVendedor;
